export default {
	'app.docs.components.icon.search.placeholder': 'Search icons here, click icon to copy code',
	'app.docs.components.icon.outlined': 'Outlined',
	'app.docs.components.icon.filled': 'Filled',
	'app.docs.components.icon.two-tone': 'Two Tone',
	'app.docs.components.icon.category.direction': 'Directional Icons',
	'app.docs.components.icon.category.suggestion': 'Suggested Icons',
	'app.docs.components.icon.category.editor': 'Editor Icons',
	'app.docs.components.icon.category.data': 'Data Icons',
	'app.docs.components.icon.category.other': 'Application Icons',
	'app.docs.components.icon.category.logo': 'Brand and Logos',
	'app.docs.components.icon.pic-searcher.intro':
		'AI Search by image is online, you are welcome to use it! 🎉',
	'app.docs.components.icon.pic-searcher.title': 'Search by image',
	'app.docs.components.icon.pic-searcher.upload-text':
		'Click, drag, or paste file to this area to upload',
	'app.docs.components.icon.pic-searcher.upload-hint':
		'We will find the best matching icon based on the image provided',
	'app.docs.components.icon.pic-searcher.server-error':
		'Predict service is temporarily unavailable',
	'app.docs.components.icon.pic-searcher.matching': 'Matching...',
	'app.docs.components.icon.pic-searcher.modelloading': 'Model is loading...',
	'app.docs.components.icon.pic-searcher.result-tip': 'Matched the following icons for you:',
	'app.docs.components.icon.pic-searcher.th-icon': 'Icon',
	'app.docs.components.icon.pic-searcher.th-score': 'Probability',
};
